import { createScrollTrigger } from './create-scroll-trigger';
import type { Trigger } from './types';

export const documentScrollOver: Trigger = (
  triggerName = 'documentScrollOver',
  threshold
) => {
  return createScrollTrigger({
    shouldTrigger: (ratio, threshold) => ratio >= threshold,
    valueToToggle: true,
    threshold: Number(threshold),
    triggerName
  });
};
